import * as XLSX from "xlsx-style";
import * as FileSaver from 'file-saver';

export function datenum(v, date1904) {
    if(date1904) v+=1462;
    const epoch = Date.parse(v);
    return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
};

export function resizeColumn(worksheet, lastColumn){
    let wscols = [];
    const width = {wch:20};
    for(let i = 0; i < lastColumn; ++i){
        wscols.push(width);
    }
    worksheet['!cols'] = wscols;
}

export function s2ab(s){
    let buf = new ArrayBuffer(s.length);
    let view = new Uint8Array(buf);
    for (let i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
}

export function sheet_report_convert(data){
    let ws = {};
    let range = {s: {c:10000000, r:10000000}, e: {c:0, r:0 }};
    const numberFmt = '#,##0';
    const percentageFmt = '0.0%';
    for(let R = 0; R != data.length; ++R) {
        for(let C = 0; C != data[R].length; ++C) {
            if(range.s.r > R) range.s.r = R;
            if(range.s.c > C) range.s.c = C;
            if(range.e.r < R) range.e.r = R;
            if(range.e.c < C) range.e.c = C;
            let cell = {v: data[R][C] };
            if(cell.v == null) continue;
            let cell_ref = XLSX.utils.encode_cell({c:C,r:R});
            if(typeof cell.v === 'number') {cell.t = 'n';cell.z = numberFmt}
            else if(typeof cell.v === 'boolean') cell.t = 'b';
            else if(cell.v instanceof Date) {
                cell.t = 'n'; cell.z = XLSX.SSF._table[14];
                cell.v = datenum(cell.v);
            }
            else cell.t = 's';
            //custom styles
            cell.s={
                font:{
                    name:"Arial"
                }
            }
            //header
            if(R == 0){
                cell.s={
                    font:{
                        name:"Arial",
                        bold:true,
                        sz:"11"
                    },
                    fill:{
                        fgColor:{ rgb: "FFFFAA00" }
                    }
                }
            }
            //data content
            if(R > 0){
                cell.s={
                    font:{
                        name:"Arial",
                        sz:"10"
                    }
                }
            }

            ws[cell_ref] = cell;
        }
    }
    if(range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
    return ws;
}

export function exportToExcel(excelData, fileName){
    if(!!excelData && excelData.length > 0){
        const fileType = 'application/octet-stream';
        const fileExtension = '.xlsx';
        const ws = sheet_report_convert(excelData);
        resizeColumn(ws,50);
        const wb = { Sheets: { 'Dữ liệu báo cáo': ws }, SheetNames: ['Dữ liệu báo cáo'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', bookSST:true, type: 'binary', compression:true});
        const data = new Blob([s2ab(excelBuffer)], {type: fileType});
        FileSaver.saveAs(data, fileName + fileExtension);
    }
}
export default exportToExcel;